import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { ApiError } from '../../../lib/errors';
import { rpaRepository as repo } from '../../../lib/repositories/rpa.repository';
import type { KetNoi, ThanSuaKetNoi, TrangThaiOpenCore } from '../types';
import { KHOA_RPA, thuLai } from './useRpa';

export function useKetNoi(bat = true) {
  return useQuery<KetNoi, ApiError>({
    queryKey: KHOA_RPA.ketNoi,
    queryFn: () => repo.ketNoi(),
    enabled: bat,
    staleTime: 30_000,
    retry: thuLai,
  });
}

/**
 * Lưu kết nối. Ghi phản hồi vào cache để form dựng lại từ đúng thứ máy chủ đã nhận, rồi làm mới mọi dữ liệu đọc từ
 * OpenCore: đổi địa chỉ hay JWT là đổi nguồn của Project, Workflow, sơ đồ…
 */
export function useLuuKetNoi() {
  const qc = useQueryClient();
  return useMutation<KetNoi, ApiError, ThanSuaKetNoi>({
    mutationFn: (than) => repo.luuKetNoi(than),
    onSuccess: (moi) => {
      qc.setQueryData(KHOA_RPA.ketNoi, moi);
      void qc.invalidateQueries({ queryKey: KHOA_RPA.goc, predicate: (q) => q.queryKey[1] !== 'ket-noi' });
    },
  });
}

/** "Kiểm tra kết nối": một lần hỏi theo yêu cầu, không phải dữ liệu sống của màn — nên là mutation, không cache. */
export function useKiemKetNoi() {
  return useMutation<TrangThaiOpenCore, ApiError, void>({ mutationFn: () => repo.trangThaiOpenCore() });
}
